import Konva from "konva";
import { IMarkupLine } from "../../IMarkupLine";

export class KonvaLine implements IMarkupLine {
  private _ref: Konva.Line;

  constructor(params: { points: [{ x: number; y: number }]; color: string; lineWidth: number }, ref = null) {
    if (ref) {
      this._ref = ref;
      return;
    }

    if (!params.points) return;

    let konvaPoints = [];
    params.points.forEach((point) => konvaPoints.push(point.x, point.y));

    this._ref = new Konva.Line({
      stroke: params.color ?? "#ff0000",
      strokeWidth: params.lineWidth ?? 4,
      globalCompositeOperation: "source-over",
      lineCap: "round",
      lineJoin: "round",
      points: konvaPoints,
      draggable: true,
      strokeScaleEnabled: false,
    });
  }

  ref() {
    return this._ref;
  }

  id(): string {
    return this._ref.id();
  }

  enableMouseEditing(value: boolean) {
    this._ref.draggable(value);
  }

  type(): string {
    return "line";
  }

  setColor(hex: string) {
    this._ref.stroke(hex);
  }

  getColor(): string {
    return this._ref.stroke();
  }

  delete() {
    this._ref.destroy();
    this._ref = null;
  }

  getPoints(): [] {
    return this._ref.attrs.points;
  }

  setLineWidth(size: number) {
    this._ref.strokeWidth(size);
  }

  getLineWidth(): number {
    return this._ref.strokeWidth();
  }

  addPoints(points: [{ x: number; y: number }]) {
    let newPoints = this._ref.points();
    points.forEach((point) => {
      newPoints = newPoints.concat([point.x, point.y]);
    });

    this._ref.points(newPoints);
  }
}
